import type { Transaction } from 'dexie';

// Migration v2 -> v3 : ajout des 4 tables métier T1 (Client, Commande,
// CommandePizza, Pizza). Migration purement structurelle :
//  - non destructive : aucune table B-001 modifiée (SCHEMA_V3 = SCHEMA_V2 + 4 nouvelles) ;
//  - idempotente : aucune écriture n'est faite ici, donc relancer ne casse rien ;
//  - tables nouvelles : créées vides par Dexie via `version(3).stores(SCHEMA_V3)`.
// Le hook existe pour servir de point d'extension futur (logs, validations) sans
// renommage de version, et pour expliciter l'intention dans le code.
export async function upgradeAddMetierT1Tables(_tx: Transaction): Promise<void> {
  // Aucun backfill nécessaire : les 4 nouvelles tables sont vides à la création.
  return;
}
